// LIBS
import React from 'react'

// INTERFACE
class EventCalendarForm extends React.Component {
  render () {
    return (
      <div className="col-md-8 col-md-offset-2 CourseCalendarCity">
        <p style={{ textAlign: 'center' }}>Want to hold your event at Code Fellows? <a href="https://docs.google.com/forms/d/e/1FAIpQLSfooWndn_zDxUvtkpdt3B1fp32mbHPYsOWcALwKapsWbhbn2w/viewform" target="_blank">Get in touch »</a></p>
      </div>
    )
  }
}


export default EventCalendarForm



// WEBPACK FOOTER //
// ./src/components/event-calendar-form/index.js